// Attribute name used to populate the provider blocks.
export const mediaProviderBlockAttributeName = 'mediaSourceId'; // Attribute name used to poulate the consumer blocks.

export const mediaConsumerBlockAttributeName = 'mediaSourceReferenceId';
//# sourceMappingURL=constants.js.map